document.addEventListener("DOMContentLoaded", function () {
  const dataEl = document.getElementById("ProductFormData");
  if (!dataEl) return;

  const { variants, numOptions, defaultVariantId, moneyFormat } = JSON.parse(dataEl.textContent);
  const variantInput = document.getElementById("SelectedVariantId");
  const quantityInput = document.querySelector('input[name="quantity"]');

  // --- helpers ---

  function getVariantIdFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  function getSelectedOptions() {
    const selected = [];
    for (let i = 0; i < numOptions; i++) {
      const checked = document.querySelector(`input[name="option-${i}"]:checked`);
      selected.push(checked ? checked.value : null);
    }
    return selected;
  }

  function findMatchingVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

  function updatePrice(match) {
    const priceWrapper = document.querySelector('.product-price');
    if (!priceWrapper || !window.Shopify || !Shopify.formatMoney) return;

    priceWrapper.innerHTML = '';

    const price = match.price;
    const compare = match.compare_at_price;

    if (compare > price) {
      priceWrapper.classList.add('on-sale');

      const compareEl = document.createElement('s');
      compareEl.className = 'product-compare-price';
      compareEl.textContent = Shopify
        .formatMoney(compare, moneyFormat)
        .replace('.00', '');

      const priceEl = document.createElement('span');
      priceEl.className = 'price-value';
      priceEl.textContent = Shopify
        .formatMoney(price, moneyFormat)
        .replace('.00', '');

      const savingsBox = document.createElement('span');
      savingsBox.className = 'savings_box';
      const savings = Math.round(((compare - price) / compare) * 100);
      savingsBox.textContent = `${savings}% Off Sale`;

      priceWrapper.appendChild(compareEl);
      priceWrapper.appendChild(priceEl);
      priceWrapper.appendChild(savingsBox);
    } else {
      priceWrapper.classList.remove('on-sale');

      const priceEl = document.createElement('span');
      priceEl.className = 'price-value';
      priceEl.textContent = Shopify
        .formatMoney(price, moneyFormat)
        .replace('.00', '');

      priceWrapper.appendChild(priceEl);
    }
  }

  function setVariantInURL(id) {
    const newUrl = `${window.location.pathname}?variant=${id}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
  }

  function updateGallery() {
    if (window.updateGalleryButton) {
      setTimeout(window.updateGalleryButton, 500);
    }
  }

  // --- main variant update ---

  function updateVariant() {
    const currentOptions = getSelectedOptions();
    const match = findMatchingVariant(currentOptions);

    if (!match) {
      variantInput.value = "";
      return;
    }

    // update hidden input
    variantInput.value = match.id;

    // update price
    updatePrice(match);

    // push variant into URL
    setVariantInURL(match.id);

    // make sure selectors are visible
    const selectorWrapper = document.querySelector('.product_form_selectors');
    if (selectorWrapper) {
      selectorWrapper.style.display = 'flex';
    }

    // NEVER toggle sold-out / preorder stuff here – digital products ignore inventory

    // update gallery
    updateGallery();
  }

  // --- initial setup: URL variant / default variant ---

  setTimeout(function () {
    const variantIdFromURL = getVariantIdFromURL();

    if (variantIdFromURL) {
      const matchedVariant = variants.find(v => v.id == variantIdFromURL);

      if (matchedVariant && matchedVariant.options && matchedVariant.id) {
        matchedVariant.options.forEach((opt, i) => {
          const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
          if (radio) radio.checked = true;
        });

        variantInput.value = matchedVariant.id;
        updatePrice(matchedVariant);
      } else {
        const fallback = variants[0];
        if (fallback) {
          fallback.options.forEach((opt, i) => {
            const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
            if (radio) radio.checked = true;
          });
          variantInput.value = fallback.id;
          updatePrice(fallback);
          setVariantInURL(fallback.id);
        }
      }
    } else {
      const defaultVariant = variants.find(v => v.id === defaultVariantId) || variants[0];
      if (defaultVariant) {
        defaultVariant.options.forEach((opt, i) => {
          const radio = document.querySelector(`input[name="option-${i}"][value="${opt}"]`);
          if (radio) radio.checked = true;
        });
        variantInput.value = defaultVariant.id;
        updatePrice(defaultVariant);
      }
    }

    // react to option changes
    document.querySelectorAll('[name^="option-"]').forEach(input => {
      input.addEventListener("change", updateVariant);
    });
  }, 0);

  // --- quantity plus/minus (no inventory enforcement) ---

  document.addEventListener('click', function (e) {
    if (e.target.closest('.button-plus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    }

    if (e.target.closest('.button-minus')) {
      const input = e.target.closest('.input-group').querySelector('.quantity-field');
      let val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    }
  });

  // --- quantity dropdown accessibility / behavior (no inventory checks) ---

  document.addEventListener('keydown', function (e) {
    const selected = document.activeElement.closest('.quantity_dropdown_selected');
    const wrapper = selected?.closest('.quantity_dropdown_wrapper');
    if (!selected || !wrapper) return;

    if ((e.key === 'Enter' || e.key === ' ') && !wrapper.classList.contains('open')) {
      e.preventDefault();
      wrapper.classList.add('open');
    }

    if (e.key === 'Escape') {
      wrapper.classList.remove('open');
      selected.blur();
    }
  });

  document.addEventListener('keydown', function (e) {
    const wrapper = document.activeElement.closest('.quantity_dropdown_wrapper');
    if (!wrapper || !wrapper.classList.contains('open')) return;

    const options = Array.from(wrapper.querySelectorAll('.quantity_dropdown_option'));
    const focused = document.activeElement;
    const currentIndex = options.indexOf(focused);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = options[currentIndex + 1] || options[0];
      next.focus();
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = options[currentIndex - 1] || options[options.length - 1];
      prev.focus();
    }

    if (e.key === 'Enter' && focused.classList.contains('quantity_dropdown_option')) {
      e.preventDefault();
      focused.click();
    }
  });

  document.addEventListener('change', function (e) {
    const dropdown = e.target.closest('.quantity_dropdown');
    if (dropdown) {
      const new_quantity = parseInt(dropdown.value, 10);
      console.log('Dropdown quantity selected:', new_quantity);
    }
  });

  document.addEventListener('click', function (e) {
    const allWrappers = document.querySelectorAll('.quantity_dropdown_wrapper');
    const clickedWrapper = e.target.closest('.quantity_dropdown_wrapper');

    allWrappers.forEach(wrapper => {
      if (wrapper !== clickedWrapper) {
        wrapper.classList.remove('open');
      }
    });

    if (!clickedWrapper) return;

    const option = e.target.closest('.quantity_dropdown_option');
    if (option) {
      const selectedVal = option.getAttribute('data-value');
      clickedWrapper.querySelector('.quantity_dropdown_selected').textContent = selectedVal;
      clickedWrapper.querySelector('input[name="quantity"]').value = selectedVal;
      clickedWrapper.classList.remove('open');
      return;
    }

    clickedWrapper.classList.toggle('open');
  });
});


// ---- gallery button logic (copied from original, no inventory dependence) ----
(function () {
  function isVisible(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function isVideo(el){ return !!(el && (el.classList?.contains('product_video') || el.querySelector?.('video'))); }
  function normalize(u){ return (u||'').replace(/^https?:/,'').split('?')[0]; }

  window.updateGalleryButton = function () {
    const btns = document.querySelectorAll('.gallery_overlap_button');
    if (!btns.length) return;

    const deskVisible = Array.from(document.querySelectorAll('.product_thumbnail_grid .product_media')).filter(isVisible);
    const secondDesk = deskVisible[1];

    let mobileVisible = Array.from(document.querySelectorAll('#viewport_scroll li.carousel__slide.visible_cell'));
    if (!mobileVisible.length) mobileVisible = Array.from(document.querySelectorAll('#viewport_scroll li.carousel__slide')).filter(isVisible);
    const secondMobile = mobileVisible[1];

    const secondIsVideo = isVideo(secondDesk) || isVideo(secondMobile);

    let firstActive = false;
    const ab = document.getElementById('active_bullet');
    if (ab && ab.value === '1') firstActive = true;
    else {
      const vp = document.querySelector('.carousel__viewport');
      if (vp && vp.scrollLeft <= 1) firstActive = true;
    }

    if (!firstActive && deskVisible[0]) {
      const firstDesk = deskVisible[0];
      const featuredVid = document.querySelector('.product_featured_media_video');
      const featuredImg = document.querySelector('.product_featured_media_image');
      const current = (featuredVid && isVisible(featuredVid))
        ? (featuredVid.querySelector('source')?.src || '')
        : (featuredImg?.src || '');
      const firstSrc = firstDesk.dataset.videoSrc
        || firstDesk.dataset.imgUrl
        || firstDesk.querySelector('video source')?.src
        || firstDesk.querySelector('video')?.src
        || '';
      if (normalize(firstSrc) === normalize(current)) firstActive = true;
    }

    const show = firstActive && secondIsVideo;
    btns.forEach(b => b.style.display = show ? '' : 'none');
  };

  window.addEventListener('load', () => setTimeout(window.updateGalleryButton, 150));
})();
